document.addEventListener("DOMContentLoaded", function () {
  setupMenu();
});

document.addEventListener("shopify:section:load", function () {
  setupMenu();
});

function setupMenu() {
  const menuToggle = document.querySelector('.cs_mobile-menu-toggle');
  const sidebar = document.querySelector('.cs_sidebar');

  if (!menuToggle || !sidebar) return;

  menuToggle.removeEventListener("click", toggleMenu);
  menuToggle.addEventListener("click", toggleMenu);
}

function toggleMenu(event) {
  event.preventDefault();
  const sidebar = document.querySelector('.cs_sidebar');

  if (!sidebar) return;

  if (sidebar.classList.contains("cs_active")) {
    sidebar.classList.remove("cs_active");
    setTimeout(() => {
      sidebar.style.display = "none";
    }, 300);
  } else {
    sidebar.style.display = "block";
    setTimeout(() => {
      sidebar.classList.add("cs_active");
    }, 10);
  }
}
